// custom js

console.log("loaded custom js")

// custom-variant-options- js start

function triggerPriceChange(variantID,productID,variantURL) {
    // Update the price dynamically

document.querySelector("#product-add-btn-"+productID).href = variantURL;
  
var labels = document.querySelectorAll('.label-'+productID);

  console.log(labels);
    labels.forEach(function (label) {
      label.classList.remove('selected-label');
    });


  let variantOptionContainers=document.querySelectorAll(`#variant-options-${productID}`);
  
    var selectedLabel = variantOptionContainers[variantOptionContainers.length-1].querySelector(`input:checked`).parentElement;
  console.log(selectedLabel);
    if (selectedLabel) {
      selectedLabel.classList.add('selected-label');
    }
  

    const label = document.getElementById('label-'+variantID);
  
    const price = label.getAttribute('product-price');
    const comparePrice = label.getAttribute('product-compare-price');

    
    const dynamicPriceContainers = document.querySelectorAll('#dynamic-price-'+productID);

  let finalDynamicPriceContainer;

    if(dynamicPriceContainers.length == 1){
      finalDynamicPriceContainer = dynamicPriceContainers[0];
    }else
    {
      // for(let i=0;i<dynamicPriceContainers.length;i++){
      //   if(dynamicPriceContainers[i].innerHTML != ""){
      //      finalDynamicPriceContainer = dynamicPriceContainers[i];
      //     break;
      //   }
      // }

      finalDynamicPriceContainer = dynamicPriceContainers[dynamicPriceContainers.length-1];
    }
    
    if(price && comparePrice && finalDynamicPriceContainer){
    finalDynamicPriceContainer.innerHTML = `
      <span class="price price--highlight">
        <span class="visually-hidden">Sale price</span>
         ${price}
      </span>
      <span class="price price--compare">
        <span class="visually-hidden">Regular price</span>
         ${comparePrice}
      </span>
    `;
    }else {
       finalDynamicPriceContainer.innerHTML = `<span class="visually-hidden visually-hidden--inline">{{ 'products.product.price.regular_price' | t }}</span>
      <span class="price-item price-item--regular">
         ${price}
      </span>`;
    }
  }    
    
// custom-variant-options- js end

  var myElement = document.getElementById("MainContent");

  myElement.classList.remove("overflow-hidden");
  myElement.getElementsByTagName("section")[0].classList.remove("overflow-hidden");


